import React from "react";
import styled from "styled-components";
import  AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList } from "react-window";

const StyledList = styled(FixedSizeList)`
  && {
    padding-bottom: 26px;
    ::-webkit-scrollbar {
      display: none;
    }
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
    }
  }
`;

type Props = {
  rowRenderer: (input: { index: number, style: any }) => JSX.Element;
  rowCount: number;
  rowHeight: number;
};
export const List = ({ rowRenderer, rowCount, rowHeight }: Props) => (

  <AutoSizer>
    {({ width, height }: any) => {
      return (
        <StyledList
          width={width}
          height={height}
          itemCount={rowCount}
          itemSize={rowHeight}
        >
          {rowRenderer}
        </StyledList>
      );
    }}
  </AutoSizer>
);
